import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import WorkItem from '@Components/WorkItem'
import { WorkModel } from '@Entities/work/work'
import { StoresContext } from '@App/contexts'
import { useNavigate } from 'react-router'

interface CSWorkItemTableProps {
    workModels: WorkModel[]
    selectWork: (id: number | null | undefined) => void
}

const CSWorkItemTable = (props: CSWorkItemTableProps) => {
    const navigate = useNavigate()
    const { rightsholderStore, claimingToolSearchStore } = useContext(StoresContext)
    const { workModels, selectWork } = props

    const currentClaimedShares = rightsholderStore.rightsholderClaimedShares
        ? rightsholderStore.rightsholderClaimedShares.workClaimedShares
        : []

    return (
        <>
            {workModels.map((work) => (
                <WorkItem
                    data={work}
                    rightsHolderId={rightsholderStore.currentRightsholderId}
                    key={work.id ? work.id : ''}
                    claimType
                    selectWorkForClaiming={selectWork}
                    navigate={navigate}
                    claimedShare={currentClaimedShares.filter((share) => share.id === work.id)[0]}
                    onCatalogClick={() => claimingToolSearchStore.setRedirectingToCatalog(true)}
                />
            ))}
        </>
    )
}

export default observer(CSWorkItemTable)
